import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import BookTable from './pages/BookTable';
import AdminDashboard from './pages/AdminDashboard';
import MyBookings from './pages/MyBookings';
import Settings from './pages/Settings';
import CalendarView from './pages/CalendarView';
import Mveapi from './pages/Mveapi';


import Customers from './pages/Customers';
import ChatMessages from './pages/ChatMessages';
import Adminbooking from './pages/Adminbooking';
import NotFound from './pages/NotFound'; // Add this import at the top

import Admintable from './pages/Admintable';
import Freetimeslot from './pages/FreeTimeslot';



const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

// Protected Route Component
const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <div className="App">
            <Navbar />
            <Routes>
              <Route path="*" element={<NotFound />} />

              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              {/* <Route path="/register" element={<Register />} /> */}
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/book-table" 
                element={
                  <ProtectedRoute>
                    <BookTable />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/my-bookings" 
                element={
                  <ProtectedRoute>
                    <MyBookings />
                  </ProtectedRoute>
                } 
              />
           
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute adminOnly>
                    <AdminDashboard />
                  </ProtectedRoute>
                } 
              />
                 <Route 
                path="/admin/freetimeslot" 
                element={
                  <ProtectedRoute>
                    <Freetimeslot />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/settings" 
                element={
                  <ProtectedRoute adminOnly>
                    <Settings />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/calendar" 
                element={
                  <ProtectedRoute adminOnly>
                    <CalendarView />
                  </ProtectedRoute>
                } 
              />
               <Route 
                path="/admin/mveapi" 
                element={
                  <ProtectedRoute adminOnly>
                    <Mveapi />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/customers" 
                element={
                  <ProtectedRoute adminOnly>
                    <Customers />
                  </ProtectedRoute>
                } 
              />
               <Route 
                path="/admin/bookings" 
                element={
                  <ProtectedRoute adminOnly>
                    <Adminbooking />
                  </ProtectedRoute>
                } 
              />
                 <Route 
                path="/admin/tables" 
                element={
                  <ProtectedRoute adminOnly>
                    <Admintable />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/chat" 
                element={
                  <ProtectedRoute adminOnly>
                    <ChatMessages />
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
